import type { BatchCosignItem } from "@/features/cosignature/types";
import { CosignatureStatus } from "@/core/types";

import { BatchControls } from "../(batch)/BatchControls";
import { CosignatureTab } from "../types";

import { StatusSelect } from "./components/StatusSelect";
import { SupervisorAssignmentOptionValue } from "./types";
import { SupervisorAssignmentSelect } from "./components/SupervisorAssignmentSelect";

type FiltersProps = {
  onStatusChange: (value: CosignatureStatus) => void;
  onSupervisorChange: (value: SupervisorAssignmentOptionValue | null) => void;
  selectedItems: BatchCosignItem[];
  status: CosignatureStatus;
  supervisor_id: SupervisorAssignmentOptionValue | null;
  tab: CosignatureTab;
};

export function Filters({
  onStatusChange,
  onSupervisorChange,
  selectedItems,
  status,
  supervisor_id,
  tab,
}: FiltersProps) {
  return (
    <div className="tw:flex tw:justify-between tw:gap-4 tw:px-6 tw:max-md:flex-col tw:md:items-end">
      <div className="tw:flex tw:items-end tw:gap-4">
        <SupervisorAssignmentSelect onChange={onSupervisorChange} value={supervisor_id} />
        <StatusSelect onChange={onStatusChange} tab={tab} value={status} />
      </div>

      {selectedItems.length > 0 && <BatchControls items={selectedItems} />}
    </div>
  );
}
